import { SVGProps } from 'react'

export const Clock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...props}>
    <path
      fill="currentColor"
      d="M12.49 2C6.97 2 2.5 6.48 2.5 12s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10S18.02 2 12.49 2zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zM13 7h-1.5v6l5.25 3.15.75-1.23-4.5-2.67V7z"
    ></path>
  </svg>
)
